module.exports = __webpack_public_path__ + "img/carteira-de-identidade.85c202dc.png";